import { Modal,Box } from '@mui/material'
import React from 'react'
import { RotatingLines } from 'react-loader-spinner'
export default function Loader() {
    return (
        <Modal
        open={true}
        onClose={false}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '20px',
            borderRadius: '4px',
            outline: 'none',
          }}
        >
          <RotatingLines
            strokeColor="rgb(25 103 210)"
            strokeWidth="5"
            animationDuration="0.75"
            width="96"
            visible={true}
        />
        </Box>
      </Modal>
        // <div style={{ position: "fixed",
        //     top: 0,
        //     left: 0,
        //     width: "100%",
        //     height: "100%",
        //     backgroundColor: 'rgb(210 203 203 / 50%)',
        //     zindex: 9999,
        //     display: "flex",
        //     justifyContent: "center",
        //     alignItems: "center",}}></div>
    )
}
